// extracted by mini-css-extract-plugin
export default {"root":"styles__root__ZjFQq","outlined":"styles__outlined__zOfVM"};